import React from "react";
import { GiByzantinTemple } from "react-icons/gi";

export default (props) => {
  return (
    <>
      <div className="center-entire">
        <GiByzantinTemple size="10em" color="#8a8a8a" />
        <p className="text-secondary">data tidak tersedia</p>
      </div>
    </>
  );
};
